export default {"src":"/polygon/_next/static/media/dystopia.89ebb202.svg","height":34,"width":24};